var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('Role',{scopedSlots:_vm._u([{key:"webmaster",fn:function(){return [_c('SignUpDetailWebmaster')]},proxy:true},{key:"advertiser",fn:function(){return [_c('SignUpDetailAdvertiser')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }